// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectInsightsFailureRate-module_content__Mx0nKKFNstqH24S7P04_","csvDownloadWrap":"ProjectInsightsFailureRate-module_csvDownloadWrap__gYr4b0G6YKrEyDqW_mR3"};